<template>
    <div class="cleanings" v-if="date !== null">
        <div class="page-header">
            <h1>
                Cleaning

                <small class="controls">
                    {{date | moment('DD MMMM \'YY')}}&nbsp;

                    <span class="pe-7s-angle-left-circle navigatable" @click="previous()"></span>&nbsp;
                    <span class="pe-7s-angle-right-circle navigatable" @click="next()"></span>
                </small>

                <div class="pull-right hidden-print">
                    <date-picker v-model="date" :config="{format: 'DD MMMM YYYY'}"></date-picker>
                </div>

                <div class="pull-right hidden-print">
                    <print></print>&nbsp;
                </div>
            </h1>
        </div>

        <loader v-if="!hasLoaded"></loader>

        <template v-else>
            <div class="text-center">
                <span class="lead">{{reservations.length}} cleaning(s)</span>
            </div>

            <br />

            <div class="list-group">
                <div class="list-group-item" v-for="reservation in reservations">
                    <div class="action" v-if="isToday && hasLoadedCleanings && !hasBeenCleaned(reservation.room)" @click="markCleaned(reservation.room)">
                        <button type="button" class="btn btn-primary">
                            Mark as cleaned
                        </button>
                    </div>

                    <div class="status">
                        <span class="label label-danger text-uppercase" v-if="isLeaving(reservation)">
                            Checkout
                        </span>

                        <span class="label label-warning text-uppercase" v-else>
                            Regular
                        </span>
                    </div>

                    &nbsp;

                    <div class="meta" @click="openReservation(reservation.id)">
                        {{reservation.room.title}}<br />

                        <span class="text-muted">{{reservation.name}}</span>
                    </div>

                    <div class="clearfix"></div>
                </div>
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
    .cleanings {
        .controls {
            > * {
                cursor: pointer;
            }
        }

        .status,
        .meta {
            float: left;
            display: inline-block;
            height: 40px;
            margin-right: 20px;
        }

        .status {
            width: 70px;
            text-align: center;
            padding-top: 8px;
        }

        .action {
            float: right;
            padding-top: 5px;
        }
    }
</style>

<script>
    import Room from '@/components/calendar/Room'
    import Loader from '@/components/layout/Loader'
    import Print from '@/components/layout/Print'

    const ReservationService = require('@/services/reservations/ReservationService')
    const CleaningService = require('@/services/cleaning/CleaningService')

    import DatePicker from 'vue-bootstrap-datetimepicker'

    const moment = require('moment')

    export default {
        data() {
            return {
                date: null,
                reservations: [],
                hasLoaded: false,
                loaded: 0,
                cleanings: [],
                hasLoadedCleanings: false
            }
        },

        computed: {
            isToday() {
                const today = new moment()

                const date = moment(this.date)

                return today.format('DD/MM/YYYY') === date.format('DD/MM/YYYY')
            }
        },

        watch: {
            loaded() {
                if (this.loaded !== this.rooms.length) {
                    return
                }

                this.hasLoaded = true
            },

            date() {
                this.load()
            }
        },

        mounted() {
            this.load()
            this.setDefaultDate()
            this.loadCleanings()
        },

        methods: {
            setDefaultDate() {
                this.date = moment()
            },

            previous() {
                this.reset()

                this.date = moment(this.date.subtract(1, 'day'))
            },

            /**
             * Next
             **/
            next() {
                this.reset()

                this.date = moment(this.date.add(1, 'day'))
            },

            reset() {
                this.loaded = 0
                this.hasLoaded = false
            },

            load() {
                if (!this.date) {
                    return
                }

                this.hasLoaded = false

                let date = moment(this.date)
                date = date.subtract(1, 'day')

                const options = {
                    sort: [
                        {
                            key: 'room.order',
                            direction: 'ASC'
                        }
                    ],

                    includes: ['room'],

                    filter_groups: [
                        {
                            filters: [
                                {
                                    key: 'belongsToDate',
                                    value: date.format('YYYY-MM-DD'),
                                    operator: 'eq'
                                },
                            ]
                        }
                    ]
                }

                ReservationService.findAll(options, (response) => {
                    const data = response.data

                    this.reservations = data.rows
                    this.hasLoaded = true
                })
            },

            isLeaving(reservation) {
                const date = moment(this.date)

                date.subtract(1, 'day')

                return (moment(reservation.departure.date).format('YYYY-MM-DD') === date.format('YYYY-MM-DD'))
            },

            loadCleanings() {
                this.hasLoadedCleanings = false

                const options = {
                    includes: ['room'],

                    sort: [{
                        key: 'created',
                        direction: 'DESC'
                    }],

                    filter_groups: [
                        {
                            filters: [
                                {
                                    key: 'created',
                                    value: this.date.format('YYYY-MM-DD'),
                                    operator: 'gte'
                                }
                            ]
                        }
                    ]
                }

                CleaningService.findAll(options, (response) => {
                    const data = response.data

                    this.cleanings = data.rows
                    this.hasLoadedCleanings = true
                })
            },

            hasBeenCleaned(room) {
                const matchingCleanings = this.cleanings.filter((cleaning) => {
                    return cleaning.room.id === room.id
                })

                return matchingCleanings.length > 0
            },

            markCleaned(room) {
                this.hasLoadedCleanings = false

                CleaningService.create({room: room.id}, () => {
                    this.loadCleanings()
                })
            },

            openReservation(id) {
                this.$router.push({
                    name: 'reservations.view',
                    params: {
                        id: id
                    }
                })
            }
        },

        components: {
            Loader,
            Room,
            DatePicker,
            Print
        }
    }
</script>


// WEBPACK FOOTER //
// Cleaning.vue?209ea102